import axios from "axios"
import qs from 'qs';
import ApiStore from "./ApiStore";
var querystring = require('querystring');

export class BackupcarStore extends ApiStore{
  constructor() {
    super();
  }

  loadCarReservation(used_date,completeFunc,errorFunc){
    axios.get('/backupcar/car_reservation?used_date='+used_date)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  // delPMFixingTask(task_id,completeFunc,errorFunc){
  //   axios.delete('/workdoc/pmfixingtask/'+task_id)
  //   .then(function(response){
  //     console.log(response.data)
  //     let result = response.data
  //     if(result.status==='OK')
  //       completeFunc(result)
  //     else
  //       errorFunc(result)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //     errorFunc({status:'error',desc:error});
  //   })
  // }

  saveCarReservation(postData,completeFunc,errorFunc) {
    axios.post('/backupcar/car_registration',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  // loadReservationItems() {
  //   return new Promise((resolve, reject) => {
  //     axios.get('/backupcar/reservation_items?start_date=01/10/2020&end_date=31/10/2020')
  //       .then(function (response) {
  //         console.log(response)
  //         resolve(response.data)
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //         reject(error);
  //       })
  //   })
  // }

  loadAppointmentReturnList(year,month,day,searchBy,query,start,length,completeFunc){
    year = year - 543
    axios.get('/backupcar/appointmentreturn_list/?format=json&year='+year+'&month='+month+'&day='+day+'&q='+query+"&cat="+searchBy+'&start='+start+'&length='+length)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadReservationItems(start_date,end_date,completeFunc, errorFunc) {
    axios.get('/backupcar/reservation_items?start_date='+start_date+'&end_date='+end_date)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  saveReservationItems(postData,completeFunc,errorFunc) {
    axios.post('/backupcar/car_reservation',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })  
  }

  delReservationItems(task_id,completeFunc,errorFunc){
    axios.delete('/backupcar/car_reservation/'+task_id)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  loadCarReadyReserved(completeFunc, errorFunc) {
    axios.get('/backupcar/car_ready_reserved')
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

  loadReservationItem(brId,completeFunc, errorFunc) {
    axios.get('/backupcar/reservation_item/'+brId)
      .then(function (response) {
        console.log(response)
        completeFunc(response.data)
      })
      .catch(function (error) {
        console.log(error);
        if (errorFunc !== undefined)
          errorFunc(error)
      })
  }

}

export default new BackupcarStore()


// WEBPACK FOOTER //
// ./src/stores/BackupcarStore.js